import { actionTypes } from "./actions";
import getInitialState from "../get-initial-state";
import { helpers } from "../../common/lib";

export default function(state = getInitialState.list(), action) {
  switch (action.type) {
    case actionTypes.ASSET_FOUND_ELSEWHERE_GET_SUCCESS: {
      const { assetFoundElsewhere } = action.payload;
      return helpers.getListReducer(state, assetFoundElsewhere);
    }
    default: {
      return state;
    }
  }
}
